import '../styles/screen.scss';

import Vue from 'vue';
import MuseumMap from "./MuseumMap.vue";
import MiniMap from "./MiniMap.vue";

console.log('Hello world');

let museumVueApp = null;
let haveCookiesConsent = false;

window.osmCookiesCall = function osmCookiesCall() {
	console.log('Something is happening.');
	haveCookiesConsent = true;
	if(museumVueApp) {
		museumVueApp.cookiesAllowed = true;
	}
}

function onReady() {
	museumVueApp = new Vue({
		el: '#museo',
		data() {
			return {
				cookiesAllowed: false,
			}
		},
		watch: {
			cookiesAllowed: function(val) {
				console.log('Vue detected cookies are allowed: ' + val);
			}
		},
		components: {
			'museum-map': MuseumMap,
		},
		mounted() {
			let self = this;
			if(haveCookiesConsent) {
				self.cookiesAllowed = true;
			}
		}
	});

	new Vue({
		el: '#minimap',
		data() {
			return {
				cookiesAllowed: false,
			}
		},
		watch: {
			cookiesAllowed: function(val) {
				console.log('Vue detected cookies are allowed: ' + val);
			}
		},
		components: {
			'minimap': MiniMap,
		},
		mounted() {
			let self = this;
			if(haveCookiesConsent) {
				self.cookiesAllowed = true;
			}
		}
	});
}

document.addEventListener('DOMContentLoaded', onReady);
